import { render, staticRenderFns } from "./Institutional.vue?vue&type=template&id=672cac89&scoped=true&"
import script from "./Institutional.vue?vue&type=script&lang=js&"
export * from "./Institutional.vue?vue&type=script&lang=js&"
import style0 from "./Institutional.vue?vue&type=style&index=0&id=672cac89&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672cac89",
  null
  
)

export default component.exports